import { ReactElement, ReactNode } from 'react';
import Footer from '../ui/Footer';
import MainContentsLayout from './MainContentsLayout';

// パブリックレイアウト
// トップページや記事ページ用の誰もがアクセスできる画面のレイアウト
function PublicLayout({ children }: { children: ReactNode }): ReactElement {
  return (
    <>
      <div className="flex min-h-screen flex-col flex-1 w-full lg:w-6/12 mx-auto">
        {/* メインコンテンツ */}
        <MainContentsLayout>{children}</MainContentsLayout>
      </div>
      {/* フッター */}
      <Footer />
    </>
  );
}

export default PublicLayout;
